import React,{useState} from 'react';
import {appDetails} from '../services/appDetails';
import {Button} from './ui';

export default function AppDetails(){
  const [details,setDetails]=useState(''),[message,setMessage]=useState('');
  const copy=async()=>{
    const value=appDetails();setDetails(value);
    try{await navigator.clipboard.writeText(value);setMessage('App details copied. Paste them into your support conversation.');}
    catch{setMessage('Select and copy the details below.');}
  };
  return <details className="text-sm border-t pt-3"><summary className="cursor-pointer text-gray-500">App details</summary><p className="text-gray-500 mt-3">Screen measurements for help with display problems.</p><Button variant="secondary" className="mt-3" onClick={()=>void copy()}>Copy app details</Button>{message&&<p role="status" className="mt-2 text-gray-500">{message}</p>}{details&&<textarea aria-label="App details" readOnly value={details} rows={6} className="mt-3 w-full rounded-lg border p-3 font-mono text-xs"/>}</details>;
}
